module.exports = __webpack_public_path__ + "img/40_69_003_520.dad713ca.jpg";